import { useState, useEffect } from "react";
import { Modal, Box, Button, TextField, Grid } from "@mui/material";

// Supabase
import supabase from "../../supabaseClient";

// Components
import { useNotification } from "../utils/Notification";
import { trackEvent } from "../utils/Utils";
import { useTranslation } from "react-i18next";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "80%", md: "60%", lg: "40%" },
  maxHeight: "90vh",
  bgcolor: "background.paper",
  borderRadius: "24px",
  boxShadow: "0 24px 48px rgba(0,0,0,0.2)",
  border: "1px solid rgba(255, 255, 255, 0.1)",
  overflowY: "auto",
  p: { xs: 3, md: 5 },
};

export default function File({ open, onClose, file }) {
  const [fileName, setFileName] = useState("");
  const [fileDescription, setFileDescription] = useState("");

  // Components
  const { showNotification } = useNotification();
  const { t } = useTranslation();

  useEffect(() => {
    if (file) {
      setFileName(file.name);
      setFileDescription(file.description);
    }
  }, [file]);

  const handleSubmit = async () => {
    trackEvent("file-form_submit");
    try {
      const { error } = await supabase
        .from("files")
        .update([
          {
            name: fileName,
            description: fileDescription,
          },
        ])
        .eq("id", file.id);

      if (error) {
        throw error; // Throw the error to be caught in the catch block
      }

      showNotification(t("file.updatedSuccess"), "success");
      setFileName("");
      setFileDescription("");
      onClose();
    } catch (error) {
      showNotification(`${t("file.errorSaving")}: ${error.message}`, "error");
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={t("file.fileName")}
              value={fileName}
              onChange={(e) => setFileName(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label={t("file.fileDescription")}
              value={fileDescription}
              onChange={(e) => setFileDescription(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              onClick={handleSubmit}
              fullWidth
              sx={{
                borderRadius: "8px",
                fontWeight: "bold",
                py: 1.5,
                mt: 2,
                background: "linear-gradient(90deg, #7949E7 0%, #9A67ED 100%)",
                color: "#fff",
                boxShadow: "0 4px 14px 0 rgba(121, 73, 231, 0.39)",
                "&:hover": { background: "linear-gradient(90deg, #6B53BB 0%, #7949E7 100%)" }
              }}
            >
              {t("file.updateButton")}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
